import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/jira-service-desk.vue
var s = {
	name: "DtIconJiraServiceDesk",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["fill"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--jira-service-desk"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Jira Service Desk",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		i("path", {
			d: "m13.322 9.894 5.441.034a.848.848 0 0 1 .674 1.358L11.407 22a5.707 5.707 0 0 1-1.155-7.983l3.07-4.123Z",
			fill: `url(#${e.uniqueID}a)`
		}, null, 8, l),
		t[1] || (t[1] = i("path", {
			d: "m10.25 14.007-5.408-.034a.848.848 0 0 1-.674-1.355L12.118 2a5.707 5.707 0 0 1 1.154 7.983l-3.022 4.024Z",
			fill: "#2684FF"
		}, null, -1)),
		i("defs", null, [i("linearGradient", {
			id: `${e.uniqueID}a`,
			x1: "13.109",
			y1: "10.695",
			x2: "15.395",
			y2: "17.607",
			gradientUnits: "userSpaceOnUse"
		}, [...t[0] || (t[0] = [i("stop", { "stop-color": "#0052CC" }, null, -1), i("stop", {
			offset: "1",
			"stop-color": "#2684FF"
		}, null, -1)])], 8, u)])
	], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=jira-service-desk.js.map